export const devToEmails =
  "deepu@quloi.com";

export const devCCEmails = [
  "sunill@quloi.com",
  "nihalp@quloi.com",
  "mungare@quloi.com",
  "Pratiksha@quloi.com",
  "Shwetad@quloi.com",
];

export const liveOnboardingEmails = [
  "Akshay@quloi.com",
  "arachana@ataimpex.com",
  "angadc@quloi.com",
  "supplyimpex@ataimpex.com",
  "abhishek.h@quloi.com",
  "ganesh@quloi.com",
  "Pranavn@quloi.com",
];

export const poAcceptanceToMailLive =
  "supplyimpex@ataimpex.com,s.shinde@ataimpex.com,v.kshirsagar@ataimpex.com";

export const poAcceptanceCCMailLive = [
  "arachana@ataimpex.com",
];

export const revisedPOCCMailLive = [
  "arachana@ataimpex.com",
  "supplyimpex@ataimpex.com",
  "s.shinde@ataimpex.com",
  "v.kshirsagar@ataimpex.com",
];

export const revisedPriceCCMailLive = [
  "arachana@ataimpex.com",
  "s.shinde@ataimpex.com",
  "v.kshirsagar@ataimpex.com",
];

export const revisedPriceTOMailLive =
  "supplyimpex@ataimpex.com";
